// Store the product post_id in local storage

// Attempt to get the element using document.getElementById
const productcomparegrid = document.querySelector('[data-js=productcomparegrid]');
if (productcomparegrid) {
	// Update Function
	function updateProductStatus() {
		// Create a flat array of all product id's stored
		const groups = Object.keys(localStorage)
			.filter((key) => key.startsWith('comparegroup'))
			.map((key) => localStorage[key]);

			console.log('groups', groups);

		const products = [];
		groups.forEach((value) => {
			products.push(JSON.parse(value));
		});

		console.log('products', products);

		products.flat().forEach((value) => {
			const product = document.querySelectorAll(`[data-productid='${value}']`);
			product.forEach((element) => {
				element.checked = true;
			});
		});

		// update .comparestatus
		// const comparegroups = Object.keys(localStorage).filter((key) => key.startsWith('comparegroup'));
		// comparegroups.forEach((values) => {
		// 	const comps = JSON.parse(localStorage.getItem(values)).length;
		// 	document.getElementById('comparecount').innerHTML = `${comps}`;
		// });
	}

	function clearCheckmarks() {
		const clist = document.getElementsByClassName('productcard-compare-status');
		for (let i = 0; i < clist.length; ++i) {
			clist[i].checked = false;
		}
	}

	function resetAll() {
		console.log('reset all');
		const comparegroups = Object.keys(localStorage).filter((key) => key.startsWith('comparegroup'));
		const newArr = [];
		// localStorage.setItem(comparegroups, JSON.stringify(newArr));
		for (var i = 0; i < comparegroups.length; i++) {
			localStorage.setItem(comparegroups[i], JSON.stringify(newArr));
		}
		document.getElementById('comparecount').innerHTML = 0;
		clearCheckmarks();
		updateProductStatus();
	
	}

	// on load, setup the page from storage
	window.addEventListener('load', (event) => {
		clearCheckmarks();
		// updateProductStatus();
		resetAll();
	});

	// Clear all button fuctionality
	document.addEventListener('click', (event) => {
		if (!event.target.matches('#reset-all')) return;
		event.preventDefault();
		resetAll();
	});

	function saveProductStatus() {
		// Set vars
		const group = this.dataset.comparegroup;
		const product = this.dataset.productid;

		const comps = JSON.parse(localStorage.getItem(group)) || [];

		// when checked - add item to local storage;
		if (this.checked) {
			// is comps full?
			if (comps.length >= 3) {
				// eslint-disable-next-line no-alert
				alert('You have reached the maximum number of items to compare. You may only compare up to 3 products');
				this.checked = false;
			} else if (!comps.includes(product)) {
				// add product id to localstorage if it is not allready
				comps.push(product);
				localStorage.setItem(group, JSON.stringify(comps));
			}
		// when unchecked remove the product id from localstorage
		} else {
			let index = comps.indexOf(product);
			while (index > -1) {
				comps.splice(index, 1);
				index = comps.indexOf(product);
			}
			localStorage.setItem(group, JSON.stringify(comps));
		}

		document.getElementById('comparecount').innerHTML = comps.length;
		// run update just in case
		updateProductStatus();
	}

	// saveProductStatus of clicked checkbox
	const checkboxs = document.getElementsByClassName('productcard-compare-status');

	Array.from(checkboxs).forEach((element) => {
		element.addEventListener('change', saveProductStatus);
	});


	function msieversion() {

		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
	
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
		{
			
		let removeBtns = document.getElementById('remove-ie')
		let pdfLink = document.getElementById('ie-pdf-link')
		removeBtns.classList.add('remove');
		pdfLink.classList.add('show')

		const removeCheckboxs = document.getElementsByClassName('productcard-compare');
		Array.from(removeCheckboxs).forEach((element) => {
			element.classList.add('remove');
		});

		}
		else  // If another browser, return 0
		{
			console.log('not ie');
		}
	
		return false;
	}

	msieversion();
}

// Handle keyboard navigation for product compare checkboxes
const compareChecks = document.querySelectorAll('.productcard-compare');
compareChecks.forEach((item) => {
	item.addEventListener('keyup', (el) => {
        if(el.key === 'Enter') {
			const checkbox = el.target.querySelector('.productcard-compare-status');
			const changeEvent = new Event('change');
			
            if (checkbox.checked === true) {
            	checkbox.checked = false;
			} else {
                checkbox.checked = true;
            }

			checkbox.dispatchEvent(changeEvent);
        }
    });
});
